import { SelectionModel } from '@angular/cdk/collections';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollableWindow,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  ElementRef,
  input,
  TemplateRef,
  viewChild,
} from '@angular/core';

import {
  RowAutosizeVirtualScrollDirective,
  VirtualScrollModule,
} from '@blaze-runtime/engine-ui-feature';
import { ResizeBehavior } from '@blaze-shared/elements-domain';
import { trackByIndex } from '@blaze-shared/shared-util';

@Component({
  selector: 'be-table-body',
  templateUrl: './table-body.component.html',
  styleUrls: ['./table-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CdkFixedSizeVirtualScroll,
    CdkVirtualScrollViewport,
    CdkVirtualScrollableWindow,
    VirtualScrollModule,
    CdkVirtualForOf,
    NgTemplateOutlet,
  ],
  exportAs: 'blazeTableBody',
})
export class TableBodyComponent {
  virtualScrollDisabled = input<boolean>(false);
  isHeaderFloating = input<boolean>(false);
  tableWrapperRect = input<{ x: number; width: number; height: number }>();
  idColumnName = input<string>();
  rowHeightBehavior = input<ResizeBehavior>('fixed');
  isVirtualScrollRegistered = input<boolean>(false);

  data = input.required<Record<string, any>[]>();
  focus = input.required<SelectionModel<unknown>>();
  rowHeightPx = input.required<number>();

  tableBodyElement = viewChild('tableBody', { read: ElementRef });
  virtualScrollStrategy = viewChild(RowAutosizeVirtualScrollDirective);

  content = contentChild(TemplateRef);

  protected readonly trackByIndex = trackByIndex;

  dataWithRowIndex = computed(() => {
    let i = 0;
    const data = this.data();
    return data.map((row, idx) => {
      if (row.__groupBy === undefined) {
        return { i: i++, row };
      }
      const nextGroup = data[idx + 1];
      // if next row is a group & is on the same level → current group is collapsed
      if (nextGroup?.__groupBy !== undefined && nextGroup.__level === row.__level) {
        i += row.__groupCount;
      }
      return { i: -1, row };
    });
  });

  tableBodyMinWidthPx = computed(() =>
    this.isHeaderFloating() ? this.tableWrapperRect()?.width : undefined,
  );

  minBufferPx = computed(() => this.rowHeightPx() * 2);
  maxBufferPx = computed(() => this.rowHeightPx() * 4);
}
